import React, { useState, useMemo } from 'react';
import {
  Table, Card, Input, Button, Space, Tag, Typography, Form, DatePicker,
  Segmented, Alert, message,
} from 'antd';
import { SearchOutlined, ReloadOutlined, DownloadOutlined } from '@ant-design/icons';
import SearchSelect from '../../../components/SearchSelect/SearchSelect';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

// ──────────────────────────────────────────────
// Mock 数据 — TODO: 联调时替换为接口数据
// 变更记录：改号成功后按「方案产品 → 整机产品」留痕
// ──────────────────────────────────────────────
const CURRENT_ENTERPRISE = { id: 'ENT_M01', name: '深圳模组科技有限公司' };

const ENTERPRISES = [
  { id: 'ENT_M01', name: '深圳模组科技有限公司' },
  { id: 'ENT_C01', name: '东莞康林物联网有限公司' },
  { id: 'ENT_C02', name: '成都云视科技有限公司' },
];

const MOCK_RECORDS = [
  {
    key: 'r1', license: 'A01M012604210133',
    planProductName: '智能云台摄像机方案', planProductId: 'P_ECO_001',
    planCompanyName: '深圳模组科技有限公司', planCompanyId: 'ENT_M01',
    machineProductName: '智能云台摄像机-康林高配版', machineProductId: 'P_DRV_001',
    machineCompanyName: '东莞康林物联网有限公司', machineCompanyId: 'ENT_C01',
    changedAt: '2026-04-21 10:12:33',
    sourceType: 'tool', workOrderName: '云台方案→康林高配版 改号', workOrderId: 'WO-CHG-001', operationNo: null,
  },
  {
    key: 'r2', license: 'A01M012604210267',
    planProductName: '智能云台摄像机方案', planProductId: 'P_ECO_001',
    planCompanyName: '深圳模组科技有限公司', planCompanyId: 'ENT_M01',
    machineProductName: '智能云台摄像机-康林高配版', machineProductId: 'P_DRV_001',
    machineCompanyName: '东莞康林物联网有限公司', machineCompanyId: 'ENT_C01',
    changedAt: '2026-04-21 10:13:01',
    sourceType: 'tool', workOrderName: '云台方案→康林高配版 改号', workOrderId: 'WO-CHG-001', operationNo: null,
  },
  {
    key: 'r3', license: 'A01M012604220155',
    planProductName: '智能云台摄像机方案', planProductId: 'P_ECO_001',
    planCompanyName: '深圳模组科技有限公司', planCompanyId: 'ENT_M01',
    machineProductName: '智能云台摄像机-云视标准版', machineProductId: 'P_DRV_002',
    machineCompanyName: '成都云视科技有限公司', machineCompanyId: 'ENT_C02',
    changedAt: '2026-04-22 14:20:10',
    sourceType: 'tool', workOrderName: '云台方案→云视标准版 改号', workOrderId: 'WO-CHG-002', operationNo: null,
  },
  {
    key: 'r4', license: 'A01M012604220288',
    planProductName: '智能云台摄像机方案', planProductId: 'P_ECO_001',
    planCompanyName: '深圳模组科技有限公司', planCompanyId: 'ENT_M01',
    machineProductName: '智能云台摄像机-康林低配版', machineProductId: 'P_DRV_003',
    machineCompanyName: '东莞康林物联网有限公司', machineCompanyId: 'ENT_C01',
    changedAt: '2026-04-23 09:30:00',
    sourceType: 'manual', workOrderName: null, workOrderId: null, operationNo: 'GH20260423093000123C33',
  },
  {
    key: 'r5', license: 'A01M012604230310',
    planProductName: '4G低功耗电池摄像机方案', planProductId: 'P_ECO_002',
    planCompanyName: '深圳模组科技有限公司', planCompanyId: 'ENT_M01',
    machineProductName: '4G电池摄像机-康林版', machineProductId: 'P_DRV_004',
    machineCompanyName: '东莞康林物联网有限公司', machineCompanyId: 'ENT_C01',
    changedAt: '2026-04-25 16:35:12',
    sourceType: 'manual', workOrderName: null, workOrderId: null, operationNo: 'GH20260425163505456C33',
  },
  {
    key: 'r6', license: 'A01M012604220299',
    planProductName: '智能云台摄像机方案', planProductId: 'P_ECO_001',
    planCompanyName: '深圳模组科技有限公司', planCompanyId: 'ENT_M01',
    machineProductName: '智能云台摄像机-康林低配版', machineProductId: 'P_DRV_003',
    machineCompanyName: '东莞康林物联网有限公司', machineCompanyId: 'ENT_C01',
    changedAt: '2026-04-23 09:32:20',
    sourceType: 'tool', workOrderName: '云台方案→康林低配版 改号', workOrderId: 'WO-CHG-003', operationNo: null,
  },
];

const toCSV = (rows) => rows.map((r) => r.map((c) => `"${String(c == null ? '' : c).replace(/"/g, '""')}"`).join(',')).join('\n');

const triggerDownload = (filename, content) => {
  const blob = new Blob(['\ufeff' + content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

const ProductCell = ({ name, id }) => (
  <div>
    <div style={{ fontWeight: 500 }}>{name}</div>
    <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{id}</Text>
  </div>
);

const CompanyCell = ({ name, id }) => (
  <div>
    <div style={{ fontWeight: 500 }}>{name}</div>
    <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{id}</Text>
  </div>
);

const DeviceOwnershipLog = () => {
  const [view, setView] = useState('enterprise');

  // 查询条件
  const [form] = Form.useForm();
  const [applied, setApplied] = useState({ license: '', range: null, companyId: undefined });

  const fetchCompanyOptions = (kw) => Promise.resolve(
    ENTERPRISES
      .filter((e) => !kw || e.name.includes(kw) || e.id.includes(kw))
      .map((e) => ({ value: e.id, label: `${e.name}（${e.id}）` })),
  );

  const filtered = useMemo(() => {
    let list = MOCK_RECORDS;
    if (view === 'enterprise') {
      list = list.filter((r) => r.planCompanyId === CURRENT_ENTERPRISE.id || r.machineCompanyId === CURRENT_ENTERPRISE.id);
    } else if (applied.companyId) {
      list = list.filter((r) => r.machineCompanyId === applied.companyId || r.planCompanyId === applied.companyId);
    }
    if (applied.license.trim()) {
      const kw = applied.license.trim().toLowerCase();
      list = list.filter((r) => r.license.toLowerCase().includes(kw));
    }
    if (applied.range && applied.range[0] && applied.range[1]) {
      const start = applied.range[0].format('YYYY-MM-DD');
      const end = applied.range[1].format('YYYY-MM-DD');
      list = list.filter((r) => {
        const d = r.changedAt.slice(0, 10);
        return d >= start && d <= end;
      });
    }
    return [...list].sort((a, b) => b.changedAt.localeCompare(a.changedAt));
  }, [view, applied]);

  const handleSearch = () => {
    const values = form.getFieldsValue();
    setApplied({
      license: values.license || '',
      range: values.range || null,
      companyId: values.companyId,
    });
  };

  const handleReset = () => {
    form.resetFields();
    setApplied({ license: '', range: null, companyId: undefined });
  };

  const handleViewChange = (val) => {
    setView(val);
    form.resetFields();
    setApplied({ license: '', range: null, companyId: undefined });
  };

  const handleExport = () => {
    if (filtered.length === 0) {
      message.warning('当前筛选结果为空，无可导出数据');
      return;
    }
    const header = ['License', '方案产品', '方案ID', '整机产品', '产品ID', '整机企业', '整机企业ID', '变更时间', '来源', '工单/操作编号'];
    const rows = filtered.map((r) => [
      r.license, r.planProductName, r.planProductId,
      r.machineProductName, r.machineProductId,
      r.machineCompanyName, r.machineCompanyId, r.changedAt,
      r.sourceType === 'tool' ? '产测工具' : '后台管理',
      r.sourceType === 'tool' ? `${r.workOrderName}（${r.workOrderId}）` : r.operationNo,
    ]);
    triggerDownload(`变更记录_${Date.now()}.csv`, toCSV([header, ...rows]));
  };

  const columns = [
    {
      title: 'License', dataIndex: 'license', width: 200,
      render: (t) => <Text copyable style={{ fontFamily: 'monospace' }}>{t}</Text>,
    },
    {
      title: '方案产品', key: 'plan', width: 220,
      render: (_, r) => <ProductCell name={r.planProductName} id={r.planProductId} />,
    },
    {
      title: '整机产品', key: 'machine', width: 240,
      render: (_, r) => <ProductCell name={r.machineProductName} id={r.machineProductId} />,
    },
    {
      title: '整机企业', key: 'machineCompany', width: 220,
      render: (_, r) => <CompanyCell name={r.machineCompanyName} id={r.machineCompanyId} />,
    },
    { title: '变更时间', dataIndex: 'changedAt', width: 170 },
    {
      title: '来源', key: 'source', width: 260,
      render: (_, r) => (
        r.sourceType === 'tool' ? (
          <div>
            <Tag color="blue" style={{ border: 'none' }}>产测工具</Tag>
            <div style={{ fontSize: 12 }}>{r.workOrderName}</div>
            <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.workOrderId}</Text>
          </div>
        ) : (
          <div>
            <Tag color="green" style={{ border: 'none' }}>后台管理</Tag>
            <div style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.operationNo}</div>
          </div>
        )
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={4} style={{ margin: 0 }}>变更记录</Title>
        <Space>
          <Text type="secondary" style={{ fontSize: 12 }}>mock 角色视角切换</Text>
          <Segmented
            value={view}
            onChange={handleViewChange}
            options={[{ label: '企业视角', value: 'enterprise' }, { label: '平台视角', value: 'platform' }]}
          />
        </Space>
      </div>

      <Alert
        type="info"
        showIcon
        closable
        style={{ marginBottom: 16 }}
        message="记录设备（License）的整机产品变更：由方案产品改号到目标整机。来源区分「产测工具（改号工单）」与「后台管理（操作编号）」。"
      />

      <Card bordered={false} style={{ marginBottom: 16, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Form form={form} layout="inline" style={{ rowGap: 12 }}>
          <Form.Item name="license" style={{ marginBottom: 0 }}>
            <Input placeholder="请输入 License 模糊查询" allowClear style={{ width: 220 }} />
          </Form.Item>
          <Form.Item name="range" style={{ marginBottom: 0 }}>
            <RangePicker placeholder={['变更开始日期', '变更结束日期']} />
          </Form.Item>
          {view === 'platform' && (
            <Form.Item name="companyId" style={{ marginBottom: 0 }}>
              <SearchSelect
                fetchOptions={fetchCompanyOptions}
                placeholder="所属企业"
                style={{ width: 260 }}
              />
            </Form.Item>
          )}
          <Form.Item style={{ marginBottom: 0 }}>
            <Space>
              <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      <Card
        bordered={false}
        style={{ borderRadius: 12 }}
        extra={<Button icon={<DownloadOutlined />} onClick={handleExport}>导出</Button>}
      >
        <Table
          columns={columns}
          dataSource={filtered}
          rowKey="key"
          scroll={{ x: 1550 }}
          style={{ whiteSpace: 'nowrap' }}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
          locale={{ emptyText: '暂无变更记录' }}
        />
      </Card>
    </div>
  );
};

export default DeviceOwnershipLog;
